module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("人事行政主管")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)负责贯彻执行国家有关人事方面的政策法规，结合本公司情况，制定并实施公司的人力资源规划和具体计划\n      (2)定期评价本公司人力资源状况，提出人力资源开发计划并实施；\n      (3)根据各部门的人力需求计划，负责对人才的引进和招聘工作进行具体操作，并制定并维护招聘渠道.\n(4)制定和修改公司人力资源方面相关的规章制度，经批准后，负责监督执行；\n(5)适应公司发展的实际情况和组织机构的调整，确定各部门的职务设置，并制定相应的职位说明书\n(6)负责公司社会保险系统的管理及社保、福利等相关事务的办理；\n(7)负责员工的人事调动、晋升、降级、辞退、离职等异动手续的相关处理；\n(8)负责入职手续、人事资料收集工作及员工档案的完整性；\n(9)在部门负责人领导下，指导各部门绩效考核的实施和推进绩效的管理工作，制定合理的员工薪酬制度，并根据公司发展需要适时调整薪酬方案\n(10)负责公司与员工、员工与员工之间劳动关系的处理，保证劳动合同签订的及时率；\n(11)负责每月的工资核算，保证及时准确的完成，交予总经理审核并签字确认；\n(12)领导安排的其他事宜；\n")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)本科以上学历，人力资源管理、工商管理等相关专业；\n(2)5年以上相关工作经验，2年以上人力资源主管工作经验，互联网行业从业经验优先；\n(3)对现代企业人力资源管理模式有系统的了解和丰富的实践经验.\n(4)对人力资源管理各个职能模块均有深入的认识，能够指导各个职能模块的工作；,以及相关供应链管理系统、客户关系管理系统和物流管理中的业务流程；\n(5)熟悉国家、地区及企业关于合同管理、薪金制度、用人机制、保险福利待遇、培训等方面的法律法规及政策；\n(6)具有战略、策略性思维，有能力建立、整合不同的工作团队；\n(7)具有解决复杂问题的能力；很强的计划性和实施执行的能力；\n(8)具有激励、沟通、协调、团队领导能力，责任心、事业心强；\n(9)有人力资源管理师资格者优先考虑；")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c6a099ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/join_us/HomeJoinPreduce.vue
// module id = 171
// module chunks = 1